module.exports = __webpack_public_path__ + "img/ozo_login.d12dba4b.svg";